import styled from 'styled-components';

import { COLORS } from 'constants/colors';

interface PostContainerProps {
  isMeetingOrPoll: boolean;
}

export const PostContainer = styled.div<PostContainerProps>`
  background: ${COLORS.BgContainer};
  width: 674px;
  border-radius: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin-bottom: 16px;
  padding-bottom: ${(props) => (props.isMeetingOrPoll ? '16px' : '0')};
`;
